module.exports = __webpack_public_path__ + "img/icon_smart_printer.656fd709.png";